// extracted by mini-css-extract-plugin
module.exports = {"wizardArrow":"LandingWizardArrow_wizardArrow__WLlnt","done":"LandingWizardArrow_done__7e6Ii","icon":"LandingWizardArrow_icon__u_qTH"};